/**
 * 原始数据
 * @see http://seatable.myhexin.com/workspace/1496/dtable/F10-pluto%E7%BB%84%E4%BB%B6%E6%8C%91%E9%80%89/?tid=V9oj&vid=0000
 *
 * excel 转换 json 工具
 * @see https://exceltojson.com/
 */
const metadata = [
  {
    '组件名称-中文': '3D 柱状图',
    类别: '[bar][3D]',
    '组件命名-英文': '3D Bar',
    类型: '用于在三维空间中以柱形图展示数据分布情况',
    '意图-中文': '对比, 趋势, 空间',
    '意图-英文': 'comparison, spatial, trend'
  },
  {
    '组件名称-中文': '3D 散点图',
    类别: '[scatter][3D]',
    '组件命名-英文': '3D Scatter',
    类型: '用于在三维空间中展示数据之间的空间和密度分布',
    '意图-中文': '对比, 分布, 空间',
    '意图-英文': 'comparison, spatial, distribution'
  },
  {
    '组件名称-中文': '面积图',
    类别: '[area][stacked]',
    '组件命名-英文': 'Area',
    类型: '用于显示数据在时间周期内的变化趋势',
    '意图-中文': '趋势',
    '意图-英文': 'trend'
  },
  {
    '组件名称-中文': '带状区间趋势折线图',
    类别: '[line]',
    '组件命名-英文': 'Banded Interval Trend Line',
    类型: '用来显示数据在一个连续的时间间隔或者时间跨度上的连续变化',
    '意图-中文': '趋势',
    '意图-英文': 'trend'
  },
  {
    '组件名称-中文': '柱状图',
    类别: '[bar]',
    '组件命名-英文': 'Bar',
    类型: '用柱形方式来显示数据项在一段时间内变化趋势',
    '意图-中文': '趋势, 对比',
    '意图-英文': 'comparison, trend'
  },
  {
    '组件名称-中文': '环形饼图',
    类别: '[pie]',
    '组件命名-英文': 'Donut Pie',
    类型: '用于突出显示不同组别的数据的分布情况和所占的比例',
    '意图-中文': '构成, 占比',
    '意图-英文': 'composition, proportion'
  },
  {
    '组件名称-中文': '双指标折线与柱状组合图',
    类别: '[bar][line]',
    '组件命名-英文': 'Double Indicator Bar And Line Combination Chart',
    类型: '用于分析两个指标之间的关联关系和趋势变化',
    '意图-中文': '趋势',
    '意图-英文': 'trend'
  },
  {
    '组件名称-中文': '双饼图',
    类别: '[pie]',
    '组件命名-英文': 'Double Pie',
    类型: '用于展示两个不同类别的数据之间的大小关系和比例关系',
    '意图-中文': '对比, 构成, 占比',
    '意图-英文': 'comparison, composition, proportion'
  },
  {
    '组件名称-中文': '动态蜂群图',
    类别: '[bubble]',
    '组件命名-英文': 'Dynamic BeeSwarm',
    类型: '用于显示在一段时间内多个数据点在空间中的分布和动态变化。',
    '意图-中文': '对比, 分布, 趋势, 空间',
    '意图-英文': 'comparison, distribution, trend, spatial'
  },
  {
    '组件名称-中文': '动态气泡图',
    类别: '[bubble]',
    '组件命名-英文': 'Dynamic Bubble',
    类型: '用于显示在一段时间内多个数据点在空间中的位置和大小变化。',
    '意图-中文': '对比, 分布',
    '意图-英文': 'comparison, distribution'
  },
  {
    '组件名称-中文': '动态折线图',
    类别: '[line]',
    '组件命名-英文': 'Dynamic Line',
    类型: '用于显示在一段时间内数据项随时间变化的趋势',
    '意图-中文': '趋势',
    '意图-英文': 'trend'
  },
  {
    '组件名称-中文': '动态排名条形图',
    类别: '[bar]',
    '组件命名-英文': 'Dynamic Ranking Horizontal Bar',
    类型: '用于显示在一段时间内各项指标的动态排名',
    '意图-中文': '排名, 对比',
    '意图-英文': 'rank, comparison'
  },
  {
    '组件名称-中文': '动态排名折线图',
    类别: '[line]',
    '组件命名-英文': 'Dynamic Ranking Line',
    类型: '用来显示在一段时间内各项指标的动态变化趋势，特别是对于排名变化趋势。',
    '意图-中文': '对比, 排名',
    '意图-英文': 'rank, comparison'
  },
  {
    '组件名称-中文': '动态排名双向条形图',
    类别: '[bar][twoway]',
    '组件命名-英文': 'Dynamic Ranking Two-way Horizontal Bar',
    类型: '用来同时显示一个数据项的两个维度指标的排名变化趋势',
    '意图-中文': '排名, 对比, 关系',
    '意图-英文': 'comparison, rank, relation'
  },
  {
    '组件名称-中文': '动态沃洛诺伊图',
    类别: '[area]',
    '组件命名-英文': 'Dynamic Voronoi',
    类型: '用来显示一组数据项根据数值大小随时间变化形成的区域分布',
    '意图-中文': '对比, 占比, 关系',
    '意图-英文': 'comparison, relation, proportion'
  },
  {
    '组件名称-中文': '仪表盘',
    类别: '[gauge]',
    '组件命名-英文': 'Gauge',
    类型: '用于直观地展示关键绩效指标的当前状态',
    '意图-中文': '结果',
    '意图-英文': 'result'
  },
  {
    '组件名称-中文': '分组柱状图',
    类别: '[bar]',
    '组件命名-英文': 'Grouped Bar',
    类型: '用柱形方式来显示不同类别的数据在各组中的分布情况',
    '意图-中文': '对比, 分布, 趋势',
    '意图-英文': 'comparison, distribution, trend'
  },
  {
    '组件名称-中文': '分组条形图',
    类别: '[bar]',
    '组件命名-英文': 'Grouped Horizontal Bar',
    类型: '用于展示不同类别的数据在各组中的比对情况',
    '意图-中文': '对比, 排名',
    '意图-英文': 'rank, comparison'
  },
  {
    '组件名称-中文': '分组堆叠柱状图',
    类别: '[bar][stacked]',
    '组件命名-英文': 'Grouped Stacked Bar',
    类型: '将不同类别的数据按照其所属的组别进行堆叠来展示各组数据的大小和比例关系',
    '意图-中文': '趋势, 构成, 对比',
    '意图-英文': 'comparison, trend, composition'
  },
  {
    '组件名称-中文': '折线图',
    类别: '[line]',
    '组件命名-英文': 'Line',
    类型: '用于显示数据在时间周期内的变化规律',
    '意图-中文': '趋势',
    '意图-英文': 'trend'
  },
  {
    '组件名称-中文': '多维 3D 散点图',
    类别: '[scatter][3D]',
    '组件命名-英文': 'Multi-dimensional 3D Scatter',
    类型: '用于在三维空间中展示各个变量之间的空间密度分布和相互作用',
    '意图-中文': '对比, 分布, 关系, 空间',
    '意图-英文': 'comparison, spatial, distribution, relation'
  },
  {
    '组件名称-中文': '多维散点图',
    类别: '[scatter]',
    '组件命名-英文': 'Multi-dimensional Scatter',
    类型: '用散点分布方式来显示多组数据下的关系和分布情况',
    '意图-中文': '对比, 分布, 关系',
    '意图-英文': 'comparison, distribution, relation'
  },
  {
    '组件名称-中文': '多指标环状仪表盘',
    类别: '[gauge]',
    '组件命名-英文': 'Multi-indicator Ring Gauge',
    类型: '用于展示多个关键绩效指标的当前进度和目标达成情况',
    '意图-中文': '关系',
    '意图-英文': 'relation'
  },
  {
    '组件名称-中文': '多指标堆叠柱状图',
    类别: '[bar][stacked]',
    '组件命名-英文': 'Multi-indicator Stacked Bar',
    类型: '用于同时展示多个指标的数据在各分类中的分布情况',
    '意图-中文': '对比, 构成',
    '意图-英文': 'comparison, composition'
  },
  {
    '组件名称-中文': '多指标堆叠折线图',
    类别: '[line][stacked]',
    '组件命名-英文': 'Multi-indicator Stacked Line',
    类型: '用于清晰比较同类指标下多个变量之间的相对高度和变化速度',
    '意图-中文': '趋势, 对比',
    '意图-英文': 'comparison, trend'
  },
  {
    '组件名称-中文': '多折线图',
    类别: '[line]',
    '组件命名-英文': 'Multiple Line',
    类型: '用于同时比较和分析多组数据随时间变化的趋势',
    '意图-中文': '趋势, 对比',
    '意图-英文': 'comparison, trend'
  },
  {
    '组件名称-中文': '南丁格尔玫瑰图',
    类别: '[pie]',
    '组件命名-英文': 'Nightingale Chart',
    类型: '用来显示同组周期性数据的分布和对比情况',
    '意图-中文': '占比, 对比, 构成',
    '意图-英文': 'comparison, composition, proportion'
  },
  {
    '组件名称-中文': '数值文本',
    类别: '[word]',
    '组件命名-英文': 'Numeric Text',
    类型: '用于文本结果的直接展示',
    '意图-中文': '结果',
    '意图-英文': 'result'
  },
  {
    '组件名称-中文': '饼图',
    类别: '[pie]',
    '组件命名-英文': 'Pie',
    类型: '用来表示同数据项下各部分在整体中所占的比例',
    '意图-中文': '构成, 占比',
    '意图-英文': 'composition, proportion'
  },
  {
    '组件名称-中文': '极坐标柱状图',
    类别: '[bar]',
    '组件命名-英文': 'Polar Bar',
    类型: '用于展示单组数据项中数值在同维度内的大小比较',
    '意图-中文': '对比',
    '意图-英文': 'comparison'
  },
  {
    '组件名称-中文': '正负双指标对比折线图',
    类别: '[Line][twoway]',
    '组件命名-英文': 'Positive and Negative Double Indicator Comparison Line',
    类型: '用来同时显示一个数据项正负两维度指标的变化趋势',
    '意图-中文': '趋势, 关系',
    '意图-英文': 'trend, relation'
  },
  {
    '组件名称-中文': '正负双指标求和条形图',
    类别: '[bar][twoway]',
    '组件命名-英文': 'Positive and Negative Double Indicator Sum Bar',
    类型: '用于同时展示两个具有相关关系的正向指标和负向指标的总量和差异量',
    '意图-中文': '对比, 排名, 关系',
    '意图-英文': 'comparison, rank, relation'
  },
  {
    '组件名称-中文': '比例柱状图',
    类别: '[bar]',
    '组件命名-英文': 'Proportional Bar',
    类型: '以同高度柱形方式用以展示同数据项下各部分在整体中的比例关系',
    '意图-中文': '对比, 构成, 占比',
    '意图-英文': 'comparison, composition, proportion'
  },
  {
    '组件名称-中文': '雷达图',
    类别: '[radar]',
    '组件命名-英文': 'Radar',
    类型: '用于比较同组但不同类数据之间的相对位置和变化情况',
    '意图-中文': '对比, 构成',
    '意图-英文': 'comparison, composition'
  },
  {
    '组件名称-中文': '散点图',
    类别: '[scatter]',
    '组件命名-英文': 'Scatter',
    类型: '用来显示数据项在两个变量之间的相关性和分布情况',
    '意图-中文': '对比, 分布',
    '意图-英文': 'comparison, distribution'
  },
  {
    '组件名称-中文': '堆叠面积图',
    类别: '[area][stacked]',
    '组件命名-英文': 'Stacked Area',
    类型: '用于比较不同变量之间随时间变化后的相对高度和变化速度',
    '意图-中文': '对比, 趋势',
    '意图-英文': 'comparison, trend'
  },
  {
    '组件名称-中文': '堆叠柱状图',
    类别: '[bar][stacked]',
    '组件命名-英文': 'Stacked Bar',
    类型: '用来显示数据项下各部分在整体中所占的构成关系',
    '意图-中文': '趋势, 构成, 对比',
    '意图-英文': 'comparison, trend, composition'
  },
  {
    '组件名称-中文': '堆叠条形图',
    类别: '[bar]',
    '组件命名-英文': 'Stacked Horizontal Bar',
    类型: '用于展示多个分类数据项中各组成部分的比例关系和相对大小比较',
    '意图-中文': '对比, 构成, 排名',
    '意图-英文': 'comparison, rank, composition'
  },
  {
    '组件名称-中文': '堆叠折线图',
    类别: '[line][stacked]',
    '组件命名-英文': 'Stacked Line',
    类型: '用于清晰比较多个变量之间的相对高度和变化速度',
    '意图-中文': '对比, 趋势',
    '意图-英文': 'comparison, trend'
  },
  {
    '组件名称-中文': '矩形树图',
    类别: '[area]',
    '组件命名-英文': 'TreeMap',
    类型: '用于理解同类数据之间的层次结构和比例关系',
    '意图-中文': '关系, 构成',
    '意图-英文': 'relation, composition'
  },
  {
    '组件名称-中文': '瀑布图',
    类别: '[bar]',
    '组件命名-英文': 'Waterfall',
    类型: '用于展示数据的层级关系和层级数据计算变化过程',
    '意图-中文': '构成, 关系, 结果',
    '意图-英文': 'relation, composition'
  }
];

export default metadata.reduce((result, item) => {
  result[item['组件名称-中文']] = {
    __origin: item,
    types_en: item['类别'].match(/\[.+?\]/g).map(item_ => item_.replace(/[[\]]/g, '')),
    purpose_en: item['意图-英文'].split(/，\s|,\s*/).map(item_ => item_.trim()),
    purpose_zh: item['意图-中文'].split(/，\s|,\s*/).map(item_ => item_.trim())
  };

  return result;
}, {});
